import { FilterValueDTO } from 'business/models/Models';
import React, { useEffect, useState } from 'react';
import { getMinMaxDates } from '../utils';

interface Props {
  selectedValues: string[];
  selectedFilters: FilterValueDTO[];
  minDate: string;
  maxDate: string;
  onChange?: (values: string[]) => void;
}

const FilterDateSelection = (props: Props) => {
  const { selectedValues, selectedFilters, minDate, maxDate, onChange } = props;
  const [minDateValue, setMinDateValue] = useState<string>();
  const [maxDateValue, setMaxDateValue] = useState<string>();

  const handleDateChange = (newValue: string, isMinDate: boolean) => {
    let minDateTime = new Date(minDateValue);
    let maxDateTime = new Date(maxDateValue);

    if (isMinDate) {
      if (newValue) {
        minDateTime = new Date(newValue);
        setMinDateValue(newValue);
      } else {
        minDateTime = null;
        setMinDateValue(null);
      }
    } else {
      maxDateTime = new Date(newValue);
      setMaxDateValue(newValue);
    }

    if (maxDateTime) {
      maxDateTime.setHours(23);
      maxDateTime.setMinutes(59);
      maxDateTime.setSeconds(59);
    }

    const filteredValues = selectedValues.filter((dateTime) => {
      const dateTimeTimestamp = new Date(dateTime).getTime();
      if (!minDateTime) {
        return (
          dateTimeTimestamp === new Date(null).getTime() ||
          dateTimeTimestamp <= maxDateTime.getTime()
        );
      } else {
        return (
          dateTimeTimestamp >= minDateTime.getTime() &&
          dateTimeTimestamp <= maxDateTime.getTime()
        );
      }
    });

    if (onChange) {
      onChange(filteredValues);
    }
  };

  const handleMinDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleDateChange(event.target.value, true);
  };

  const handleMaxDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleDateChange(event.target.value, false);
  };

  useEffect(() => {
    const [minDate, maxDate] = getMinMaxDates(selectedFilters?.map((item) => item.value));
    setMinDateValue(selectedFilters.some((item) => !item?.value) ? null : minDate);
    setMaxDateValue(maxDate);
  }, [minDate, maxDate]);

  return (
    <div
      id="filterdataselection-main-container"
      className="flex flex-row justify-between p-3"
    >
      <div
        id="filterdataselection-start-date-wrapper"
        className="flex flex-row items-center gap-2"
      >
        <label
          id="filterdataselection-start-date-label"
          htmlFor="startDate"
          className="m-0"
        >
          Start Date
        </label>
        <input
          id="filterdataselection-start-date-input"
          type="date"
          value={minDateValue}
          min={minDate}
          max={maxDate}
          onChange={handleMinDateChange}
        />
      </div>
      <div
        id="filterdataselection-end-date-wrapper"
        className="flex flex-row items-center gap-2"
      >
        <label id="filterdataselection-end-date-label" htmlFor="endDate" className="m-0">
          End Date
        </label>
        <input
          id="filterdataselection-end-date-input"
          type="date"
          value={maxDateValue}
          min={minDate}
          max={maxDate}
          onChange={handleMaxDateChange}
        />
      </div>
    </div>
  );
};

export default FilterDateSelection;
